import { useMutation } from '@tanstack/react-query';
import { useBffClient } from './client';

export interface AgentAuthorizeRequest {
  hostname: string;
  platform: string;
  machineGuid?: string;
  macAddress?: string;
  orgId: string;
  codeChallenge: string;
}

export interface AgentAuthorizeResponse {
  code: string;
}

export function useAuthorizeAgent() {
  const client = useBffClient();
  return useMutation({
    mutationFn: (request: AgentAuthorizeRequest) =>
      client.post<AgentAuthorizeResponse>('/bff/agent/authorizations', request),
  });
}
